import React from "react";
import { Dialog, DialogContent } from '@material-ui/core';

const beginnerVideoData = [
    {
        image: '/manual/procedures/3. Arkusz Personel.jpg',
        video: '/manual/procedures/3. Arkusz Personel.mp4',
    },    
    {
        image: '/manual/procedures/PERSONEL%201.jpg',
        video: '/manual/procedures/PERSONEL%201.mp4',
    },
    {
        image: '/manual/procedures/PERSONEL%202.jpg',
        video: '/manual/procedures/PERSONEL%202.mp4',
    },
    {
        image: '/manual/procedures/PERSONEL%203.jpg',
        video: '/manual/procedures/PERSONEL%203.mp4',
    },
    {
        image: '/manual/procedures/PERSONEL%204.jpg',
        video: '/manual/procedures/PERSONEL%204.mp4',
    },
    {
        image: '/manual/procedures/PERSONEL%205.jpg',
        video: '/manual/procedures/PERSONEL%205.mp4',
    },
];


export default function BeginnersVideoList() {
    const [selectedVideo, setSelectedVideo] = React.useState(undefined);
    const [videoListOpen, setVideoListOpen] = React.useState(false);
    const [videoPlayDialogOpen, setVideoPlayDialogOpen] = React.useState(false);

    const handleVideoSelect = (video) => {
        setSelectedVideo(video);
        setVideoListOpen(false);
        setVideoPlayDialogOpen(true);
    };

    
    const PlayIcon = () => (
        <svg width="40px" height="40px" viewBox="-1 0 14 14" id="meteor-icon-kit__solid-play-s" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_iconCarrier"><path fill-rule="evenodd" clip-rule="evenodd" d="M0 1.00154V13.0015C0 13.7788 0.84797 14.259 1.5145 13.859L11.5145 7.859C12.1618 7.4706 12.1618 6.5325 11.5145 6.1441L1.5145 0.14405C0.84797 -0.25586 0 0.22425 0 1.00154z" fill="#758CA3"></path></g></svg>
    )

    return <div><div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', padding: '20px', justifyContent: 'center' }}>
        {
            beginnerVideoData.map(
                (v, i) => {
                    return <div className="videoListItem" style={{width: '40%', margin: '30px'}} onClick={() => handleVideoSelect(v)}>
                        <div style={{ position: 'relative' }}>
                            <img src={v.image} alt={'Video nr ' + i} />
                            <div style={{
                                position: 'absolute',
                                top: '50%',
                                left: '50%',
                                opacity: '.5',
                                color: 'gray'
                            }}>
                                <PlayIcon />
                            </div>
                        </div>
                    </div>
                }
            )
        }
    </div>
        <Dialog

            maxWidth='90vw'
            open={videoPlayDialogOpen}
            onClose={() => setVideoPlayDialogOpen(false)}
            aria-labelledby="dialog-title"
            aria-describedby="dialog-description"

        >
            <DialogContent style={{ display: 'flex', flexDirection: 'column', margin: '0px', padding: '0px' }}>
                <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '3px 10px 3px 0px' }}>
                    <button
                        onClick={() => {
                            const div = document.getElementById('videoControl');
                            if (div.requestFullscreen)
                                div.requestFullscreen();
                            else if (div.webkitRequestFullscreen)
                                div.webkitRequestFullscreen();
                            else if (div.msRequestFullScreen)
                                div.msRequestFullScreen();
                        }
                        }
                        style={{ backgroundColor: 'white', color: '#0b6471', fontWeight: 'bold', textDecorationLine: 'underline' }}
                    >
                        Pełen ekran
                    </button>
                    <button
                        onClick={() => setVideoPlayDialogOpen(false)}
                        style={{ backgroundColor: 'white', color: '#0b6471', fontWeight: 'bold', textDecorationLine: 'underline' }}
                    >
                        Zamknij
                    </button>
                </div>
                <video id='videoControl' controls autoPlay style={{ width: '80vw' }}>
                    <source src={selectedVideo && selectedVideo.video} type="video/mp4" />
                    Video control not supported by browser
                </video>

            </DialogContent>
        </Dialog>
    </div>
};

// export default function VideoProcedury() {
//     return (
//         <div style={{ display: 'flex', flexDirection: 'column', margin: '0px', padding: '0px', width: '100%', backgroundColor: 'white', alignItems: 'center' }}>
//             <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '3px 10px 3px 0px', width: '80vw' }}>
//                 <button
//                     onClick={() => {
//                         const div = document.getElementById('videoControl');
//                         if (div.requestFullscreen)
//                             div.requestFullscreen();
//                         else if (div.webkitRequestFullscreen)
//                             div.webkitRequestFullscreen();
//                         else if (div.msRequestFullScreen)
//                             div.msRequestFullScreen();
//                     }
//                     }
//                     style={{ backgroundColor: 'white', color: '#0b6471', fontWeight: 'bold', textDecorationLine: 'underline' }}
//                 >
//                     Pełen ekran
//                 </button>
//             </div>
//             <video
//                 id='videoControl' controls autoPlay style={{ width: '80vw' }}
//                 poster='/manual/tutorial/Jak_zaimportowac_plik_SRK.jpg'
//             >
//                 <source src='/manual/tutorial/Jak_zaimportowac_plik_SRK.mp4' type="video/mp4" />
//                 Video control not supported by browser
//             </video>

//         </div>
//     )
// };